import React, { useState, useEffect } from 'react';
import './CookieBanner.scss';

const CONSENT_KEY = 'cookie_consent';

function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(CONSENT_KEY);

    if (!saved) {
      // Użytkownik jeszcze nie wybrał - pokaż baner
      setVisible(true);
    } else if (saved === 'accepted') {
      // Użytkownik wcześniej zaakceptował - odśwież zgodę dla GA
      updateConsent(true);
    }
    // jeśli saved === 'rejected', nic nie robimy - zgoda zostaje "denied"
  }, []);

  function updateConsent(granted) {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: granted ? 'granted' : 'denied',
        ad_storage: granted ? 'granted' : 'denied',
      });
    }
  }

  function handleAccept() {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    updateConsent(true);
    setVisible(false);
  }

  function handleReject() {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    updateConsent(false);
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-banner">
    <p className="cookie-banner__text">
  W celu polepszenia działania strony, używamy plików cookie do analizy ruchu
  (Google Analytics - dane: adres IP, zachowanie na stronie, urządzenie). Dane są przekazywane
  do Google LLC (USA). Szczegóły znajdziesz w{' '}
  <a href="/polityka-prywatnosci" style={{ color: '#fff', textDecoration: 'underline' }}>
    Polityce Prywatności
  </a>. <br></br>Możesz zaakceptować lub odrzucić
</p>
      <div className="cookie-banner__buttons">
        <button
          className="cookie-banner__btn cookie-banner__btn--reject"
          onClick={handleReject}
        >
          Odrzuć
        </button>
        <button
          className="cookie-banner__btn cookie-banner__btn--accept"
          onClick={handleAccept}
        >
          Akceptuj
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;
